//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
    prev: {
      type: Boolean,
      default: false,
    },
    next: {
      type: Boolean,
      default: true,
    },
    submit: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onPrev() {
      this.$emit('form:prev')
    },
    onNext() {
      this.$emit('form:next')
    },
  },
}
